import React from "react";
import { SupAsset, SupAssetLabel } from "@repo/core-ui";

import type { ServiceProps } from "../../types";

export function ServiceValue({ icon, name }: ServiceProps) {
  return (
    <SupAssetLabel label={name} className="whitespace-nowrap">
      <SupAsset size="xl" logo={icon} alt={name} />
    </SupAssetLabel>
  );
}
